/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface LoyaltyDto { 
    id?: number;
    cardNumber?: string;
    points?: number;
    company?: CompanyDto;
    status?: LoyaltyDto.StatusEnum;
    companyCoupons?: number;
    availableCoupons?: number;
    activeCoupons?: number;
    displayName?: string;
    displayOffices?: boolean;
    lastUpdate?: string;
    loyaltyProgram?: ClientLoyaltyProgramDto;
}
export namespace LoyaltyDto {
    export type StatusEnum = 'ACTIVE' | 'BLOCKED';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Blocked: 'BLOCKED' as StatusEnum
    };
}


